import { useHasActivePageTour } from 'common/components';
import DraggableGuideButton from './DraggableGuideButton';
import GuideModal from './GuideModal';
import { GUIDE_CHECKLIST } from './guideConfig';
import { useGuideProgress } from './useGuideProgress';

const GuideWidget = () => {
  const { completedIds, target, setTarget } = useGuideProgress();
  // Pages with their own PageTour show a compass FloatButton in the same
  // corner — hide this global entry point then so only one is ever visible.
  const hasActivePageTour = useHasActivePageTour();

  const openFlow = (item: (typeof GUIDE_CHECKLIST)[number]) => {
    setTarget({ flow: item.flow, step: item.stepIndex });
  };

  const handleTakeTour = () => {
    const nextItem = GUIDE_CHECKLIST.find((item) => !completedIds.includes(item.id)) ?? GUIDE_CHECKLIST[0];
    openFlow(nextItem);
  };

  return (
    <>
      {!hasActivePageTour && (
        <DraggableGuideButton
          remaining={Math.max(0, GUIDE_CHECKLIST.length - completedIds.length)}
          onClick={handleTakeTour}
        />
      )}

      <GuideModal target={target} completedIds={completedIds} onClose={() => setTarget(null)} onSelect={openFlow} />
    </>
  );
};

export default GuideWidget;
